import { Typography } from '@mui/material';
import React from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { V } from '../../common/Layout';
import { Field } from '../attributes';

type DefaultValueEditorProps = {
    field: Field;
    /** Overrides the rich text editor's default placeholder */
    contentPlaceholder?: string;
};

export default function NoteAttributeEditor(props: DefaultValueEditorProps) {
    const { field, contentPlaceholder } = props;
    return (
        <FormContainer>
            <FormItem>
                <V gap={1}>
                    <Typography className="_noteLabel" color="text.primary">
                        {field.label}
                    </Typography>
                    <FormWidget
                        name={field.name}
                        component={FORM_WIDGET_COMPONENTS.richText}
                        disableTranslation
                        contentPlaceholder={contentPlaceholder || undefined}
                    />
                </V>
            </FormItem>
        </FormContainer>
    );
}
